/* eslint-disable import/no-default-export */
import React from 'react';

import DescriptionIcon from '../../icons/DescriptionIcon';

import IconBadge from './IconBadge';

const DescriptionBadge = () => <IconBadge icon={<DescriptionIcon />} />;

export default DescriptionBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/DescriptionBadge.js